import React from 'react';
import ReadingAidButton from '../../platformui/ReadingAid/reading-aid-button';
import Spinner from '../../platformui/Spinner';

const ReadingAidDynamic = (props) => {
  const ReadingAid = props.CurrentPageProps.SiteHeader.ReadingAid;
  const ReadingAidProps = {
    ReadingAidLoaded: ReadingAid.LoadedText,
    ReadingAidButtonText: ReadingAid.ButtonText,
  };
  return (
    <div className="reading-aid-block">
      <div className="reading-aid-block__content">
        {props.ReadingAidText && (
          <div className="reading-aid-block__text">
            <p>{props.ReadingAidText}</p>
          </div>
        )}
        {ReadingAid && (
          <div className="reading-aid-block__button-wrapper">
            <ReadingAidButton
              Id={null}
              Spinner={Spinner}
              ReadingAid={ReadingAidProps}
              ButtonText={ReadingAidProps.ReadingAidButtonText}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ReadingAidDynamic;
